/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Combo_Recipe_Col_QuantityInputs */

const vi_combo_recipe_col_quantity = /** @type {(inputs: Combo_Recipe_Col_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng`)
};

/**

* @param {Combo_Recipe_Col_QuantityInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const combo_recipe_col_quantity = /** @type {((inputs?: Combo_Recipe_Col_QuantityInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Combo_Recipe_Col_QuantityInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_combo_recipe_col_quantity(inputs)
});